import type { JSX } from "react";

type ItemListProps = {
  caption: string;
  items: string[];
  addItem: () => void;
  removeItem: (item: string) => void;
  editItem: (item: string) => void;
  disabled?: boolean;
};

export const ItemList = ({
  caption,
  items: items,
  addItem,
  removeItem,
  editItem,
  disabled,
}: ItemListProps): JSX.Element | null => {
  return (
    <>
      <span className="form-text">{caption}</span>
      {
        <ul className="list-group item-list">
          {items.map((item) => (
            <button
              key={item}
              className="list-group-item list-group-item-action d-flex"
              disabled={disabled}
              aria-label="Disabled"
              onClick={(e) => {
                e.preventDefault();
                editItem(item);
              }}
            >
              <span className="small">{item}</span>
              {!disabled && (
                <i
                  title="Eintrag löschen"
                  className="bi bi-x-circle-fill ms-auto focus-alert"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    removeItem(item);
                  }}
                />
              )}
            </button>
          ))}
          {!disabled && (
            <button
              title="Domain Hunzufügen"
              className="list-group-item list-group-item-action small"
              onClick={(e) => {
                e.preventDefault();
                addItem();
              }}
            >
              + Eintrag hinzufügen
            </button>
          )}
        </ul>
      }
    </>
  );
};
